export default {
  title: 'RFID EPC Cycle Report',
  inputTypeEpc: 'RFID EPC',
  inputTypeQr: 'QR Code',
  inputPlaceholderEpc: 'Enter up to 10 EPCs, separated by comma',
  inputPlaceholderQr: 'Enter up to 10 QR codes, separated by comma',
  inputHint: 'Separated by comma (,) — max 10',
  inputEmptyError: 'Please enter at least one value',
  maxInputError: 'A maximum of 10 values is supported',
  search: 'Search',
  clear: 'Clear',
  found: 'Found {x} of {y} EPC(s)',
  clickTip: 'Click an icon to view details',
  current: 'Current',
  returns: '{n} return(s)',
  times: '{n} times',
  visits: '{n} visits',
  records: '{n} record(s)',
  step: 'Step {n}',
  latestFirst: 'latest first',
  relatedEpcs: '+{n} related EPCs',
  main: 'Main',
  statusInvalidEpc: 'Invalid EPC',
  statusInvalidQr: 'Invalid QR Code',
  statusNoGlobalQr: 'No associated Global QR',
  statusNoRecord: 'No Record',
  noRecordTip: 'No cycle record found',
  plantMismatch: 'not in chain',
  stage: {
    FACTORY: 'Factory',
    DC: 'DC',
    RSC: 'RSC',
    CSC: 'CSC',
    CONSUMER: 'Consumer',
    CONSUMER_SCAN: 'Consumer Scan',
    RETURN_2C: '2C RW',
    TRANSHUB: 'Transhub',
    ADC: 'ADC',
    STORE: 'Store',
    RETURN_2B: '2B RW',
    UNKNOWN: 'Unknown'
  },
  dir: {
    ib: 'IB',
    ob: 'OB',
    cyclecount: 'CycleCount',
    inbound: 'Inbound',
    outbound: 'Outbound',
    noRecord: 'No {dir} record'
  },
  legend: {
    title: 'Legend',
    stages: 'Stages',
    direction: 'IB / OB',
    actions: 'Actions',
    both: 'Both IB and OB',
    ibOnly: 'IB only',
    obOnly: 'OB only',
    ioNote: '— shown under DC / RSC / CSC / 2C RW / 2B RW'
  },
  event: {
    rework: 'Rework',
    reprint: 'Reprint'
  },
  reworkType: {
    1: 'Missing pieces',
    2: 'Extra pieces',
    3: 'Special product',
    4: 'Manual scan by piece'
  },
  field: {
    qrCode: 'QR',
    upc: 'UPC',
    productCode: 'Product Code',
    size: 'Size',
    time: 'Time',
    operation: 'Operation',
    sourceEpc: 'Source EPC',
    stage: 'Stage',
    step: 'Step',
    actions: 'Rework / Reprint',
    createdBy: 'Created By',
    country: 'Country',
    code: 'Code',
    eventId: 'Event ID',
    eventTime: 'Event Time',
    plant: 'Plant',
    operationType: 'Operation Type',
    status: 'Status',
    cartonNo: 'Carton No',
    tunnelId: 'Tunnel ID',
    asnNo: 'ASN No',
    factoryCode: 'Factory Code',
    packlistNo: 'Packlist No',
    shipTo: 'Ship To',
    shipFrom: 'Ship From',
    platformOrderNo: 'Platform Order No',
    trackingNo: 'Tracking No',
    store: 'Store',
    type: 'Type',
    shipFromStore: 'Ship From Store',
    shipToStore: 'Ship To Store',
    cscCode: 'CSC Code',
    cscName: 'CSC Name',
    orderNumber: 'Order Number',
    scanTime: 'Scan Time',
    expressTrackingNumber: 'Express Tracking Number',
    boxNumber: 'Box Number',
    rso: 'RSO',
    returnValidation: 'Return Validation',
    matchedBy: 'Matched By',
    reworkType: 'Rework Type',
    epcs: 'EPCs'
  },
  hero: {
    title1: 'Trace',
    title2: 'every',
    title3: 'tag.',
    title4: 'Factory',
    title5: 'to feet.'
  },
  kpi: {
    found: 'EPCs found',
    stages: 'Stages',
    returns: 'Returns',
    rework: 'Rework',
    reprint: 'Reprint'
  },
  reprintOperateType: {
    '0': 'Normal',
    '1': 'Exception'
  }
}
